import React from 'react'
import * as C from './styles'

const SkillBlock = ({ skillGroup, skills }) => {
  return (
  <C.SkillBlock>
    <C.SkillBlockName>{skillGroup}</C.SkillBlockName>
    <C.SkillBlockList>
      {Object.values(skills).map((skill, index) => (
        <C.SkillsBlockListItem key={index}>
          {skill}
        </C.SkillsBlockListItem>
      ))}
    </C.SkillBlockList>
  </C.SkillBlock>
  )
}

export default SkillBlock